.red {
    color: var(--rose);
}
